
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { SistemaFormValues } from "../schemas/sistemaFormSchema";

interface BasicInfoFieldsProps {
  form: UseFormReturn<SistemaFormValues>;
}

export const BasicInfoFields = ({ form }: BasicInfoFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField
          control={form.control}
          name="nome"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nome do Sistema</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Sistema Solar" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="valorPorKwp"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Valor Base por kWp (R$)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0" {...field} placeholder="3800" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="descricao"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Descrição</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="Descreva as características do sistema"
                rows={3}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
